import { useState } from 'react';
import { useAsyncEffect, useLocalstorageState } from 'rooks';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { useCreatePaymentIntent } from '@/data/cart';
import debounce from 'lodash.debounce';

const stripePromise = loadStripe(
  import.meta.env.VITE_STRIPE_PUBLISHABLE_API_KEY
);

const PaymentWrapper = ({ cartId, children }) => {
  const [clientSecret, setClientSecret] = useState('');
  const createPaymentIntent = useCreatePaymentIntent();
  const [isDarkMode] = useLocalstorageState(`dark-mode`, true);

  // Create a debounced version of the createPaymentIntent function
  const debouncedCreatePaymentIntent = debounce(async (cartId) => {
    try {
      const response = await createPaymentIntent(cartId);
      setClientSecret(response.clientSecret);
    } catch (err) {
      // Handle error if needed
    }
  }, 100); // Adjust the debounce delay as needed

  useAsyncEffect(() => {
    debouncedCreatePaymentIntent(cartId);
  }, [cartId]);

  const colorText = isDarkMode ? '#f5f6fc' : '#1e1e1e';
  const colorPrimary = isDarkMode ? '#40424d' : '#d3d6e0';

  const appearance = {
    theme: 'stripe',
    variables: {
      fontFamily: 'Inter, system-ui, sans-serif',
      fontWeightNormal: '500',
      borderRadius: '8px',
      colorBackground: '#0A2540',
      colorPrimary: colorPrimary,
      accessibleColorOnColorPrimary: '#1A1B25',
      colorText,
      colorTextSecondary: 'white',
      colorTextPlaceholder: '#ABB2BF',
      colorDanger: '#db261c',
      tabIconColor: 'white',
      logoColor: 'dark'
    },
    rules: {
      '.Input': {
        backgroundColor: 'var(--background)',
        border: '1px solid var(--colorPrimary)'
      }
    }
  };

  if (!clientSecret) {
    return null;
  }

  return (
    <Elements stripe={stripePromise} options={{ clientSecret, appearance }}>
      {children}
    </Elements>
  );
};

export default PaymentWrapper;
